"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayCardStatus = void 0;
var MangopayCardStatus;
(function (MangopayCardStatus) {
    MangopayCardStatus[MangopayCardStatus["Creating"] = 0] = "Creating";
    MangopayCardStatus[MangopayCardStatus["Active"] = 1] = "Active";
    MangopayCardStatus[MangopayCardStatus["Inactive"] = 2] = "Inactive";
})(MangopayCardStatus || (exports.MangopayCardStatus = MangopayCardStatus = {}));
//# sourceMappingURL=MangopayCardStatus.js.map